import { Component, Inject } from "@angular/core";
import { MatLegacyDialogConfig as MatDialogConfig, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { appMatDialogDefaultConfig, isNotNullOrUndefined } from '../../../helper/helper';
import { Store } from "@ngrx/store";
import { State } from "src/app/dave-data-module/State";
import { PersonEntity } from "src/app/dave-data-module/entities/person.entity";
import { getPersons } from "src/app/dave-data-module/State/selectors/person.selectors";
import { filter, map } from "rxjs";

export interface DetailPersonPopupComponentDialogData {
    personId: number;
    headline: string;
}

@Component({
    selector: 'app-detail-person-popup',
    templateUrl: './detail-person-popup.component.html',
    styleUrls: ['./detail-person-popup.component.scss'],
})

export class DetailPersonPopupComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '30vw',
        maxWidth: '50vw',
        maxHeight: 'calc(100vh - 3.5rem)',
        closeOnNavigation: true,
    };

    public Person$: Observable<PersonEntity> = this.store.select(getPersons).pipe(
        filter(isNotNullOrUndefined),
        map((persons) => persons.find((person) => person.Id === this.data.personId)),
    )

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DetailPersonPopupComponentDialogData,
        private store: Store<State>,
    ) {}
 }